import { Injectable } from '@angular/core';
import {HttpInterceptor,HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse,HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import {LogserviceService} from '../logservice/logservice.service';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Cache-Control': 'private, max-age=1200'
  })
};

@Injectable({
  providedIn: 'root'
})
export class MetaData {

  constructor(private httpClient:HttpClient ,private logService:LogserviceService) { }
  httpHeaders = new HttpHeaders();

  backendUrl = environment.apiURL;

  // In-memory cache for metadata requests
  private metaDataCache = new Map<string, Observable<any>>();

  getObjectMetaData(objectname:string){
    console.log(objectname, "objectname")
    if (this.metaDataCache.has(objectname)) {
      return this.metaDataCache.get(objectname);
    }
    const start = performance.now();
    const observable = this.httpClient.get(this.backendUrl+'cache/getObjectMetadata/'+objectname, httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError),
        tap({
          next: () => {
            const duration = performance.now() - start;
            console.log(`[MetaData] getObjectMetaData('${objectname}') took ${duration.toFixed(2)} ms`);
          },
          error: () => {
            const duration = performance.now() - start;
            console.log(`[MetaData] getObjectMetaData('${objectname}') failed after ${duration.toFixed(2)} ms`);
          }
        })
      );
    this.metaDataCache.set(objectname, observable);
    return observable;
  }

  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime. Metadata';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }

}
